var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathTub1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.75C6.98122 2.75 5.75 3.98122 5.75 5.5V11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H21.9685C21.9891 12.8299 22 12.9137 22 13V16C22 18.2784 20.476 20.2009 18.3918 20.8037L18.7115 21.7628C18.8425 22.1558 18.6301 22.5805 18.2372 22.7115C17.8442 22.8425 17.4195 22.6301 17.2885 22.2372L16.8761 21H7.1239L6.71151 22.2372C6.58053 22.6301 6.15579 22.8425 5.76283 22.7115C5.36987 22.5805 5.1575 22.1558 5.28849 21.7628L5.60819 20.8037C3.52397 20.2009 2 18.2784 2 16V13C2 12.9137 2.01094 12.8299 2.0315 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H4.25V5.5C4.25 3.15279 6.15279 1.25 8.5 1.25C10.7087 1.25 12.524 2.93492 12.7304 5.08955C13.8769 5.37635 14.7619 6.32274 14.9589 7.50209C15.0044 7.77446 14.7761 8 14.5 8H9.5C9.22386 8 8.99563 7.77446 9.04113 7.50209C9.23536 6.3393 10.0984 5.40298 11.2214 5.10202C11.0286 3.77183 9.88363 2.75 8.5 2.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathTub1);
export default __webpack_public_path__ + "static/media/bath-tub-1.f24d654004990b947c9574fb8cb62712.svg";
export { ForwardRef as ReactComponent };